import Vue from 'vue'
import App from "./App"
import store from './store'
import router from './router'

import '@fortawesome/fontawesome-free/css/all.css'
import './assets/app.css'

import tweets from "./api/tweets";
import {ObserveVisibility} from "vue-observe-visibility";

Vue.config.productionTip = false
Vue.prototype.$apiUrl = process.env.VUE_APP_API_URL

let isMac = navigator.platform.toUpperCase().indexOf('MAC') > -1;
Vue.prototype.$isMac = isMac;
Vue.prototype.$modifierKey = isMac ? '&#8984;' : 'CTRL'
Vue.prototype.$modifierKeyEncoded = isMac ? '⌘' : 'CTRL'

// this creates a reactive object with a datetime
// that ticks up every 30 seconds. We can hook into this if we want
// something with a dynamic time comparison
Vue.prototype.$now = Vue.observable({ datetime: Date.now() })
setInterval((() => {
	Vue.prototype.$now.datetime = Date.now()
}), 1000 * 30)

Vue.directive('observe-visibility', ObserveVisibility)

new Vue({
	router,
	store,
	render: h => h(App),
	
}).$mount('#app');

